import { createSelector } from 'reselect';
import { RootState } from 'src/store';

const getSurf = (state: RootState) => state.pages.editor.surfaces.list;

const getSurfaces = createSelector([getSurf], (surfaces) => surfaces);

export default getSurfaces;
